import React from 'react'
import styled from 'styled-components'
import { faYoutube } from '@fortawesome/free-brands-svg-icons'
import FeaturedBrandLogo from '../uiComponents/FeaturedBrandLogo'
import H1 from '../uiComponents/H1'
import BrandDetail from '../uiComponents/BrandDetail'
import ShopProductBtn from '../uiComponents/ShopProductBtn'
import SectionHeader from '../uiComponents/SectionHeader'
import ProductItems from '../uiComponents/ProductItems'
import Articles from '../uiComponents/Articles'
import Videos from '../uiComponents/Videos'
import RelatedLink from '../uiComponents/RelatedLink'
import ImageWithText from '../../_common/ImageWithText'
import { Helmet } from 'react-helmet'

const Container = styled.div`
	display: flex;
	max-width: 1200px;
	width: 100%;
	flex-wrap: wrap;
	margin: 0 auto;
    padding: 0 5px;
	`
const ArticlesDiv = styled.div`
	display: flex;
	justify-content: space-around;
	width: 100%;
	flex-wrap: wrap;
`
const VideoDiv = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	width: 100%;
`
const RelatedLinkDiv = styled.div`
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	margin: 20px 0;
`
const ControlCabinetWiringContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 20px 0 20px 0;
    background-image: url('https://info.airlinehyd.com/hubfs/light-1834289-2.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    padding: 15px;
    width: 100%;
    @media (max-width: 768px) {
	    flex-direction: column;
    }
`
const ControlCabinetWiringLogoDiv = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    height: 135px;
`
const ControlCabinetWiringLogo = styled.img`
    width: 100%;
    max-width: 180px;
    object-fit: contain;
`
const ControlCabinetWiringDiv = styled.div`
    display: flex;
    flex-wrap: wrap;
    font-size: 16px;
    margin: 0px 30px 0 30px;
    align-content: center;
    flex-direction: column;
    flex: 2;
`
const ControlCabinetWiringDetails = styled.p`
    color: white;
`
const ButtonDiv = styled.div`
    text-align: center;
    margin-top: 20px;
    transition: 0.5s ease;
    &:hover {
        transform: translateY(-5px);
`
const ExploreNow = styled.a`
    color: white;
    font-weight: bold;
    text-decoration: none;
    background-color: #005eb8;
    border-radius: 3px;
    text-align: center;
    width: 30%;
    padding: 10px 15px;
    &:hover {
        text-decoration: none;
    }
`



export default function eaton() {
    const description = 'Eaton is a global technology leader in power management solutions that make electrical, ' +
        'hydraulic and mechanical power operate more efficiently, reliably, safely and sustainably. Airline carries a ' +
        'wide range of Eaton Cutler-Hammer products for circuit protection, automation and control.'

    return (
        <>
            <Helmet>
                <title>Eaton Authorized Distributor | Airline Hydraulics</title>
                <meta name="description" content="Shop online for Eaton products from Airline Hydraulics, a leading distributor. Find products and information on circuit protection, contactors, starters, protective relays, distribution, termination,transformers, power supplies, pushbuttons, pilot lights, selector switches, connectivity, relays, timers, operator interfaces, HMI/PLC, and variable frequency drives."/>
                <link rel="canonical" href={`${process.env.REACT_APP_SITE_URL}/brands/featured/eaton`} />
            </Helmet>
            <FeaturedBrandLogo src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Brand-logos/Eaton_logo.png" />
            <Container>
                <H1 text="Eaton"/>
                <BrandDetail
                    text={description}
                />
                <ShopProductBtn
                    searchTerm="Eaton"
                    text="Shop Products"
                />
                <SectionHeader
                    text="Products"
                />
                <ControlCabinetWiringContainer>
                    <ControlCabinetWiringLogoDiv>
                        <ControlCabinetWiringLogo src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Eaton/control%20cabinet%20wiring.png"  />
                    </ControlCabinetWiringLogoDiv>
                    <ControlCabinetWiringDiv>
                        <ControlCabinetWiringDetails>Ready, set, done. Learn about top fast-wiring solutions by Eaton's to make control panel wiring and design a breeze.</ControlCabinetWiringDetails>
                        <ButtonDiv><ExploreNow href="https://info.airlinehyd.com/fast-wiring" target="_blank">EXPLORE NOW</ExploreNow></ButtonDiv>
                    </ControlCabinetWiringDiv>
                </ControlCabinetWiringContainer>
                <ProductItems
                    brand="Eaton Corp"
                    searchTerm="Eaton"
                    src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Eaton/Circuit_Protection.png"
                    text={(
                        <div>
                            <p>Eaton’s complete line of low and medium voltage circuit breakers are used to provide circuit protection in a wide range of industries, where they protect against overloads and short circuits in conductors. These circuit breakers are applied in panel boards, switchboards, motor control centers, control panels, combination starters, individual enclosures, and as bus duct plug-in units. A partial list of Eaton’s circuit protection offering includes:</p>
                        </div>
                    )}
                    additionalText={(
                        <div>
                            <ul>
                                <li>Molded Case Circuit Breakers</li>
                                <li>Miniature Circuit Breakers</li>
                                <li>Rotary Disconnects</li>
                                <li>Safety Switches</li>
                            </ul>
                            <p>Before you think about what you are building next, think about how you will defend it. You need a device with connected and communicating built-in electronics, ability to generate the data to help you optimize your facilities performance, and the ability to mitigate arc ﬂash keeping your employees, customers and end-users safe. With Eaton’s new globally rated Power Defense™ molded case circuit breakers, you can now plan with conﬁdence. Start planning your defense now.</p>
                        </div>
                    )}
                    title="Circuit Protection"
                    shopUrl="/categories/CIRCUIT-PROTECTIVE-DEVICES-62/1?brandName=Eaton"

                />
                <ProductItems
                    brand="Eaton Corp"
                    searchTerm="Eaton"
                    src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Eaton/Contactors.png"
                    title="Contactors, Starters and Protective Relays"
                    shopUrl="/search?searchTerm=Eaton%20Contactors%2C%20Starters%20and%20Protective%20Relays&sortType=relevancy&nonweb=false&brands=Eaton&resultPage=1"

                    text={(
                        <div>
                            <p> Eaton offers the protection your system needs against equipment failure and danger caused by voltage faults, current conditions or excessive load requirements. Their extensive line includes:</p>
                            <ul>
                                <li>Electromechanical Contactors and Starters</li>
                                <li>Manual Motor Starters</li>
                                <li>Soft Starters</li>
                                <li>Monitoring Relays</li>
                                <li>Motor Protection Relays</li>
                                <li>Motor Protection Circuit Breakers</li>
                                <li>Manual Motor Protection</li>
                            </ul>
                        </div>
                    )}
                    reverse
                />
                <ProductItems
                    brand="Eaton Corp"
                    searchTerm="Eaton"
                    src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Eaton/Safety_Contactors.png"
                    title="Safety Contactors"
                    text="Providing enhanced levels of safety, XTSE contactors integrate to applications to not only achieve the highest safety circuits, but provide additional levels of protection that reinforce end-user safety."
                    shopUrl="/search?searchTerm=Eaton%20Safety%20Contactors&sortType=relevancy&nonweb=false&brands=Eaton&resultPage=1"
                />
                <ProductItems
                    brand="Eaton Corp"
                    searchTerm="Eaton"
                    src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Eaton/distribution_termination.png"
                    title="Distribution and Termination"
                    text="Power distribution blocks provide a means for termination of up to 12 load wires in a single point while being supplied by a single line. Terminal blocks are suited to conserve space while allowing maximum flexibility, when labor cost reduction and ease of assembly is desired. Eaton’s fuse blocks and holders provide a simple DIN mounting device for protection in control circuits."
                    shopUrl="/search?searchTerm=Eaton%20Distribution%20and%20Termination&sortType=relevancy&nonweb=false&brands=Eaton&resultPage=1"
                    reverse
                />
                <ProductItems
                    brand="Eaton Corp"
                    searchTerm="Eaton"
                    src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Eaton/pushbuttons.png"
                    title="Pushbuttons, Pilot Lights and Selector Switches"
                    shopUrl="/search?searchTerm=Eaton%20Pushbuttons%2C%20Pilot%20Lights%20and%20Selector%20Switches&sortType=relevancy&nonweb=false&brands=Eaton&resultPage=1"
                    text={(
                        <div>
                            <p>Eaton offers an extensive variety of pushbuttons, pilot lights and selector switches to suit virtually any industrial or commercial application. Choose from:</p>
                            <ul>
                                <li>22 mm Pilot Devices</li>
                                <li>30 mm Pilot Devices</li>
                                <li>Stacklights providing illuminated and audible signaling</li>
                            </ul>
                        </div>
                    )}
                />
                <ProductItems
                    brand="Eaton Corp"
                    searchTerm="Eaton"
                    src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Eaton/connectivity.png"
                    title="Connectivity"
                    text="Eaton’s SmartWire-DT system uses a continuous green flat cable located in the control cabinet to connect motor starters, pushbutton actuators, and indicator lights."
                    shopUrl="/search?searchTerm=Eaton%20Connectivity&sortType=relevancy&nonweb=false&brands=Eaton&resultPage=1"
                    reverse
                />
                <ProductItems
                    brand="Eaton Corp"
                    searchTerm="Eaton"
                    src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Eaton/relays_timers.png"
                    title="Relays and Timers"
                    shopUrl="/search?nonweb=false&resultPage=1&searchTerm=Eaton%20Relays%20and%20Timers&sortType=relevancy"
                    text={(
                        <div>
                            <p>Whether you're a machine builder or end user, control panel designer or facility maintenance manager, Eaton's expansive offering of relay options with customization capabilities can meet all of your specific application requirements:</p>
                            <ul>
                                <li>Easy Programmable Relays</li>
                                <li>Control Relays</li>
                                <li>Timing Relays</li>
                                <li>Monitoring Relays</li>
                                <li>Machine Tool Relays</li>
                                <li>Plug-in Relays</li>
                                <li>Terminal Block Relays</li>
                            </ul>
                        </div>
                    )}
                />
                <ProductItems
                    brand="Eaton Corp"
                    searchTerm="Eaton"
                    src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Eaton/operator%20interfaces.png"
                    title="Operator Interfaces"
                    text="Manufacturing environments are complex and require products that offer control, reduce downtime and increase efficiency. Eaton’s electronic operator interfaces (OI) do that while being easy to install, understand, modify and use. The features, hardware design, development software and high quality provide the best value on the market."
                    shopUrl="/search?searchTerm=Eaton%20Operator%20Interfaces&sortType=relevancy&nonweb=false&brands=Eaton&resultPage=1"
                    reverse
                />
                <ProductItems
                    brand="Eaton Corp"
                    searchTerm="Eaton"
                    src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Eaton/HMI-PLCs.png"
                    title="HMI-PLCs"
                    shopUrl="/search?searchTerm=Eaton%20HMI-PLCs&sortType=relevancy&nonweb=false&brands=Eaton&resultPage=1"
                    text="Eaton's Programmable Logic Controllers (PLCs) are microprocessor-based devices used to control industrial processes or machines. They provide advanced functions, including analog monitoring, control and high speed motion control as well as share data over communication networks."
                />
                <ProductItems
                    brand="Eaton Corp"
                    searchTerm="Eaton"
                    src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Eaton/variable_frequency_drives.png"
                    title="Variable Frequency Drives"
                    shopUrl="/search?searchTerm=Eaton%20Variable%20Frequency%20Drives&sortType=relevancy&nonweb=false&brands=Eaton&resultPage=1"
                    text="Adjustable frequency drives (also known as variable frequency drives) adjust a motor's speed to closely match output requirements, resulting in a typical energy savings of 10 to 50 percent."
                    reverse
                />
                <ProductItems
                    brand="Eaton Corp"
                    searchTerm="Eaton"
                    src="https://airlinemedia.airlinehyd.com/Static_pages/Brands/Eaton/transformers_power.png"
                    title="Transformers and Power Supplies"
                    shopUrl="/search?searchTerm=Eaton%20Transformers%20and%20Power%20Supplies&sortType=relevancy&nonweb=false&brands=Eaton&resultPage=1"
                    text="Eaton offers control power transformers that provide stepped-down voltages to machine tool control devices, enabling circuits to be isolated from all power and lighting circuits. Eaton also provides a wide selection of durable and reliable power supplies for many 24 Vdc applications in a variety of sizes and features."
                />
                <SectionHeader
                    text="Articles & Videos"
                />
                <ArticlesDiv>
                    <Articles
                        src="https://blog.airlinehyd.com/hubfs/eaton%20and%20wiring-3.png"
                        text="Control Panel Wiring | Top Three Time-Saving Technologies"
                        link="https://blog.airlinehyd.com/fast-panel-wiring"
                        detail="Before jumping into tech-talk, I want to open up with a story... A few years ago, an industrial manufacturer wanted to streamline their production (like many of us hope to do). After much deliberation, they ordered a large distributed conveyor system that would reduce their production cycle time."
                        externalLink
                    />
                    <Articles
                        src="https://blog.airlinehyd.com/hubfs/mae.png"
                        text="How MAE Standardized ALL Electrical Cabinets | Eaton CUBEFuse Success Story"
                        link="https://blog.airlinehyd.com/how-mae-standardized-all-electrical-cabinets"
                        detail="'Our electrical control cabinets now have 95% commonality. This allows us to reduce cost in both assembly and commissioning, and we are now able to pre-build our electrical control cabinets before a machine order.' Keep reading to learn how MAE accomplished this amazing feat!"
                        externalLink
                    />

                    <Articles
                        src="https://blog.airlinehyd.com/hubfs/Sensus_Eaton_Smartwire.jpg"
                        text="SmartWire Significantly Reduces Commissioning of New Production Line"
                        detail="Airline’s customer, a manufacturer and supplier of water and gas meters, was embarking on a large-scale effort to upgrade their meter production and testing line. The new line was needed to facilitate the testing of every meter produced. The customer selected a Bosch Rexroth TS Plus palletizing conveyor with multiple transfer stations and interlinking connections to handle the conveyance of the gas meters."
                        link="https://blog.airlinehyd.com/eatons-smartwire-dt-significantly-reduces-time-to-commission-new-production-line"
                        externalLink
                   />
                </ArticlesDiv>
                <SectionHeader
                    text="Configuration Tools"
                />
                <ArticlesDiv>
                    <ImageWithText
                        src="https://airlinemedia.airlinehyd.com/Item_Images/IEC%20Contactor%20&%20Starter%20-%20XT.png"
                        title="IEC Contactor & Starter - XT"
                        description="Eaton's IEC Contactor & Starter - XT Configuration Tool is a tool that allows you to configure your IEC Contactor & Starter - XT."
                        link="/bidman?productId=XTCNT"
                    />
                    <ImageWithText
                        src="https://airlinemedia.airlinehyd.com/Item_Images/22.5mm%20Pilot%20Devices%20-%20M22.png"
                        title="22.5mm Pilot Device"
                        description="Eaton's 22.5mm Pilot Device Configuration Tool is a tool that allows you to configure your 22.5mm Pilot Device."
                        link="/bidman?productId=M22APD"
                    />
                    <ImageWithText
                        src="https://airlinemedia.airlinehyd.com/Item_Images/Lighting.png"
                        title="Lighting Contactors"
                        description="Eaton's Lighting Contactors Configuration Tool is a tool that allows you to configure your Lighting Contactors."
                        link="/bidman?productId=LIGCNT"
                    />
                    <ImageWithText
                        src="https://airlinemedia.airlinehyd.com/Item_Images/NEMA%20Contactor%20&%20Starter%20-%20Freedom.png"
                        title="NEMA Contractor & Stater - Freedom"
                        description="Eaton's NEMA Contractor & Stater - Freedom Configuration Tool is a tool that allows you to configure your NEMA Contractor & Stater - Freedom."
                        link="/bidman?productId=FRNMST"
                    />
                    <ImageWithText
                        src="https://airlinemedia.airlinehyd.com/Item_Images/Definite%20Purpose%20Contactors%20and%20Starters.png"
                        title="Definite Purpose Contactor and Starters"
                        description="Eaton's Definite Purpose Contactor and Starters Configuration Tool is a tool that allows you to configure your Definite Purpose Contactor and Starters."
                        link="/bidman?productId=DPCT"
                    />
                    <ImageWithText
                        src="https://airlinemedia.airlinehyd.com/Item_Images/30mm%20Pilot%20Devices.png"
                        title="30mm Pilot Device Configuration Tool"
                        description="Eaton's 30mm Pilot Device Configuration Tool is a tool that allows you to configure your 30mm pilot device."
                        link="/bidman?productId=30MMPD"
                    />
                </ArticlesDiv>
                <SectionHeader
                    text="Videos"
                />
                <VideoDiv>
                    <Videos
                        src="https://www.youtube.com/embed/01gNSqKiokk"
                    />
                    <Videos
                        src="https://www.youtube.com/embed/jEL5t_rMxqU"
                    />
                    <Videos
                        src="https://www.youtube.com/embed/x1DBvyhsW7s?si=FdCrl9-dL09h4Ps7"
                    />
                </VideoDiv>
                <SectionHeader
                    text="Related Links"
                />
                <RelatedLinkDiv>
                    <RelatedLink
                        href="http://www.eaton.com/"
                        externalLink
                        text="Eaton's Website"
                        icon="globe-americas"
                    />
                    <RelatedLink
                        searchTerm="Eaton"
                        text="Shop Eaton Products"
                        icon="shopping-cart"
                    />
                    <RelatedLink
                        href="https://www.youtube.com/channel/UCF7vz2IAPNHv7BKTiFC9Xhw"
                        externalLink
                        text="Videos"
                        icon={faYoutube}
                    />
                    <RelatedLink
                        href="/pages/resources/catalog-request?brandName=Eaton"
                        text="Eaton Catalogs"
                        icon="address-book"
                    />
                </RelatedLinkDiv>
            </Container>
        </>
    )
}